<!--<app-header-admin></app-header-admin>-->
<app-header-admin-simulator></app-header-admin-simulator>
<div class="container admin-portal simulator-wrapper" role="main" [style.min-height.px]="minHeight">
  <router-outlet></router-outlet>
</div>
<rtn-common-footer></rtn-common-footer>